import React from "react";

function Divider({ mb = "mb-20p", mt = "", mx = "mx-20p ", className }) {
    return <hr className={mb + " " + mt + " " + mx + className} />;
}

export default Divider;
